const getGlobalState = (state, key) => (Array.isArray(state.historicalEvents[key]) ? state.historicalEvents[key].slice(0) : state.historicalEvents[key]);

export const getSoccerHistoricalEvents = (state) => getGlobalState(state, 'events');
export const getSoccerHistoricalLastEventId = (state) => getGlobalState(state, 'lastEventId');
export const getSoccerHistoricalLastDate = (state) => getGlobalState(state, 'lastDate');

